import type { ShiftReason } from '@buildmate/core';

/**
 * How each shift reason reads to a person.
 *
 * Shared rather than duplicated per page: the baseline tab shows these as
 * history and the schedule asks for one when a published date moves, and two
 * copies would drift into calling the same stored value different things.
 */
export const SHIFT_REASON_LABEL: Record<ShiftReason, string> = {
  weather: 'Weather',
  materialDelay: 'Material delay',
  ownerDecision: 'Owner decision',
  subAvailability: 'Sub availability',
  inspection: 'Inspection',
  workdayException: 'Workday exception',
  other: 'Other',
};
